import { Component, OnInit, Inject, ViewChild, ElementRef, NgZone, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, RoutesRecognized } from '@angular/router';
import { CommonService } from '../../service/common.service';
import { Constants } from '../../Utilities/Constants/constants';
import { Contactus } from '../../model/contactus';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { ContactUsService } from '../../service/contact-us.service';
import { DataService } from '../../service/data.service';
import { captchaSiteKey, homeURL, captchaSiteKeyV3, captchaSecretKeyV3 } from 'src/app/service/config.service';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { CustInfoService } from '../../service/cust-info.service';
import { Lead } from '../../model/lead';
import { Address } from 'src/app/model/address';
import { Source } from 'src/app/model/source';
import { ReCaptcha } from 'src/app/model/reCaptcha';
import { LeadHistory } from 'src/app/model/leadHistory';
import { ModelPopupComponent } from '../../shared/model-popup/model-popup.component';
import { MyAutofocusDirective } from 'src/app/directive/my-autofocus.directive';
import { filter, pairwise } from 'rxjs/operators';
declare var $: any;
declare var grecaptcha: any;
declare function facIconOne():any;
declare function facIconTwo():any;

enum loanType {
  Owner = 'F249F81E953B454E971498673FDFABF1',//HO3
  Purchase = 'a29', //Condo-HO6
  Refinance = 'a28',//Renter-HO4
  None = 'none'
}

@Component({
  selector: 'app-customer-info',
  templateUrl: './customer-info.component.html',
  styleUrls: ['./customer-info.component.css']
})
export class CustomerInfoComponent implements OnInit,AfterViewChecked {
  
  isOpen = false;
  LiveChatImage = '';
  loanType = loanType;
  captchaRequired = true;
  custForm: FormGroup;
  maxDate = new Date();
  formErrors: any = {};
  dateValid = false;
  isLoading = true;
  homeURL = '';
  newLead = true;
  mailingAddressSame = false;
  isIntoApplicationForm = false;
  isHiddenContactMe = false;
  width: string = '717px';
  siteKey = '';
  theme = 'Light';
  language = 'en';
  size = 'Normal';
  type = 'Image';
  recaptcha:string;
	badge='Bottomright';
  lstStates = [
    {
      stateName: ''
    }
  ];
  lstPhoneTypes = [{
    phoneType: '',
    phoneValue: ''
  }
  ];
  dp1AutoFocus: boolean;
  @ViewChild('EstCloseDateDP') EstCloseDateDP: ElementRef;
  @ViewChild('coApplicantDOBDP') coApplicantDOBDP: ElementRef;
  @ViewChild('ApplicantDOBDP') ApplicantDOBDP: ElementRef;
  @ViewChild('propCountys') propCounty: ElementRef;
  @ViewChild('propStreetAddress') propStreetAddress: ElementRef;
  @ViewChild('line2') line: ElementRef;
  @ViewChild('cities') city: ElementRef;
  @ViewChild('states') state: ElementRef;
  @ViewChild('ZipCodes') zipCode: ElementRef;
  @ViewChild('loantype1') loantype: ElementRef;
  @ViewChild('mailingStreet') mailingStreet: ElementRef;
  @ViewChild('mailingLine') mailingLine2: ElementRef;
  @ViewChild('mailCity') mailingCity: ElementRef;
  @ViewChild('mailState') mailingState: ElementRef;
  @ViewChild('mailZipCode') mailingZipCode: ElementRef;
  @ViewChild(ModelPopupComponent)popUp:ModelPopupComponent;

  constructor(
    public router: Router,
    public commonService: CommonService,
    public constantsObj: Constants,
    public custDetails: Lead,
    private route: ActivatedRoute,
    private contactUsService: ContactUsService,
    public dataService: DataService,
    private custInfoService: CustInfoService,

    private zone: NgZone,
    private reCaptchaV3Service: ReCaptchaV3Service,
    @Inject(captchaSiteKey) public siteKeyValue?: string,
    @Inject(captchaSiteKeyV3) public siteKeyValueV3?: string,
    @Inject(captchaSecretKeyV3) public captchaSecretKeyV3?: string,
    @Inject(homeURL) public homesiteURL?: string
  ) {
    var isSafari = this.commonService.isSafariBroswer();
    if (isSafari) {
      this.captchaRequired = false;
      this.siteKey = siteKeyValueV3;
    }
    else {
      this.siteKey = siteKeyValue;
    }
    if (!this.commonService.isSafariBroswer()) {
      $('.grecaptcha-badge').remove()
    }
    else {
      $('.grecaptcha-badge').css('display', 'block !important');
      $('.grecaptcha-badge').css('visibility', 'visible !important');
    } 
    this.LiveChatImage = constantsObj.LiveChatImage;
    this.homeURL = homesiteURL;
   
  }

  ngOnInit() {
    //this.commonService.ScrollToRTQForm();
    $('.help').tooltip({
      title: '<p class="text-justify">Possible Discounts</p>',
      html: true,
      placement: 'top'
    });
    this.getStates();
    //this.getPhoneTypes();
    this.dataService.leadHistory = new LeadHistory();
    this.dataService.leadHistory.preValue = JSON.parse(JSON.stringify(this.dataService.leadDetails));
    this.getLeadInfo();
    this.processDate(this.custDetails);
  }

  LoadChat(): any {
    var status = true;
    if (this.dataService != null &&
      this.dataService.leadDetails != null &&
      this.dataService.leadDetails.trackingInfo != null &&
      this.dataService.leadDetails.trackingInfo.currentPageName == this.dataService.leadDetails.trackingInfo.previousPageName)
      status = false;
    return status;
  }
  GotoHomePage() {
    //Needs to changed based on the environment
    window.open(this.homeURL, "_parent");
  }

  clearEstCloseDate() {
    this.custDetails.estCloseDate = null;
  }

  savePageDetails() {
    this.isLoading = true;
    this.setHourstoDate(this.custDetails);
    this.commonService.CreateLeadHistoryObj(1, this.custDetails);
    this.custInfoService
      .postLeadInfo(this.custDetails)
      .subscribe((data: Lead) => {
        this.commonService.SaveLeadHistoryFromContactBtn();
        this.custDetails = data;
        this.isLoading = false;
        this.commonService.NavigateToPage('/real-time-quote/contact');
      }, err => {
        this.isLoading = false;
        this.dataService.handleError(err); 
      }); 
  }
  setHourstoDate(leadDetails: Lead) {
    if (leadDetails != null) {
      if (leadDetails.estCloseDate != null && leadDetails.estCloseDate.getHours() <= 0) {
        leadDetails.estCloseDate.setHours(5, 30, 0, 0);
      }
      if (leadDetails.applicantDOB != null && leadDetails.applicantDOB.getHours() <= 0) {
        leadDetails.applicantDOB.setHours(5, 30, 0, 0);
      }
      if (leadDetails.coApplicantDOB != null && leadDetails.coApplicantDOB.getHours() <= 0) {
        leadDetails.coApplicantDOB.setHours(5, 30, 0, 0);
      }
    }
  }



  onSubmit(custForm) {
    this.formErrors = {};
    this.formErrors = this.commonService.getErrors(custForm, this.formErrors);
    this.formErrors = this.commonService.updateControls(custForm);
    if (!custForm.valid && this.captchaRequired) {
      this.commonService.focusFirstInvalidElement();
      return;
    }
    this.commonService.ScrollToRTQForm();
    this.setHourstoDate(this.custDetails);
    if (this.custDetails.isEmailProspect) {

      this.captchaRequired = false;
      if (custForm.valid) {
        this.isLoading = true;
        this.custInfoService.postLeadInfo(this.custDetails).subscribe((data: Lead) => {
          this.custDetails = data;
          console.log(data.eddAgencyRequiredFlag);
          this.isLoading = false;
          this.dataService.leadHistory.noUpdate = custForm['form'].pristine;
          this.commonService.NavigateToPage('/real-time-quote/credit-auth');
        }, err => {
          this.isLoading = false;
          this.dataService.handleError(err); 
        });
      } else {
        this.commonService.updateControls(custForm);
      }
    }
    else {
      if (this.captchaRequired) {

      } else {
        if (custForm.valid) {
          this.dataService.leadHistory.pageNumber = 1;
          if (this.custDetails.isIntoApplicationForm == true)
            this.dataService.leadHistory.noUpdate = custForm['form'].pristine;
          else
            this.dataService.leadHistory.noUpdate = true;
          if (this.commonService.isSafariBroswer()) {
            this.reCaptchaV3Service.execute(this.siteKey, 'homepage', (token) => {
              this.custDetails.reCaptcha.response = token;
              this.invokeSaveLead();

            });
          }
          else {
            this.invokeSaveLead();

          }
        } else {
          this.commonService.updateControls(custForm);
        }
      }

    }

  }
  invokeSaveLead() {
    this.isLoading = true;
    this.custInfoService
      .postLeadInfo(this.custDetails)
      .subscribe((data: Lead) => {
        this.custDetails = data;
        this.isLoading = false; 
        if (!this.custDetails.isDuplicateLead && this.custDetails.message == '') {
          this.captchaRequired = true;
          this.commonService.NavigateToPage('/real-time-quote/credit-auth');
        }else{ 
          $("html, body").animate({ scrollTop: $(document).height()-800 }, "slow");
        }
        
      }, err => {
        this.isLoading = false;
        this.dataService.handleError(err); 
      });
  }
  
  //For sercah icon in address line one
  changingAddressLineOne(){
    facIconTwo();
  }

  populateMailingAddress() {
    facIconOne();
    facIconTwo();
    if (this.custDetails.isMailingAddressSame == 'Yes') {
      this.custDetails.mailingAddress = JSON.parse(JSON.stringify(this.custDetails.customerAddress));
      $('#address-line-search-two').hide();
      this.mailingAddressSame = true;
    }
    else {
      $('#address-line-search-two').show();
      this.mailingAddressSame = false;
    }
  }
  clearData() {
    if (this.custDetails.isMailingAddressSame == 'No') { 
      this.custDetails.mailingAddress = new Address();
      $('#address-line-search-two').show();
    }
  }

  getLeadInfo() {
    this.custDetails = this.dataService.leadDetails;
    this.impersonateLead();
    if (this.dataService.leadDetails != null && this.dataService.leadDetails.leadID != '') {
      this.isLoading = true;
      this.newLead = false;
      if (this.dataService.leadDetails.isInit && this.dataService.leadDetails.isEmailProspect) {
        this.FetchExistingLead();
        this.dataService.leadDetails.isInit = false;
      }
      else {
		    //On previous btn from credit auth
        this.custDetails = this.dataService.leadDetails;
        if (this.custDetails.isMailingAddressSame == 'Yes') {
          this.mailingAddressSame = true;
        }
        else {
          this.mailingAddressSame = false;
        }
        this.isLoading = false;
        this.setNavigationFlag();
        $('#address-line-search-one').hide();
        $('#address-line-search-two').hide();
      }
    } else {
      this.isLoading = false;
      this.createNewLeadObj();
      this.newLead = true;
    }
  }

  hideDatePicker(dp) {
    dp.hide();
  }

  impersonateLead() {
    return;  //need to uncomment after development
    if (this.dataService.leadDetails != null) {
      this.dataService.leadDetails.leadID = '6DD91065-9404-4391-A18A-37D6CEAFE182';
      this.dataService.leadDetails.isInit = true;
      this.dataService.leadDetails.isEmailProspect = true;
    }
  }
  createNewLeadObj() {
    this.custDetails = new Lead();
    this.dataService.leadDetails=new Lead();
    this.custDetails.reCaptcha = new ReCaptcha();
    this.custDetails.reCaptcha.secretKey = this.captchaSecretKeyV3;
    this.isLoading = false;
    this.setUpdaterCompanyCode();
    this.setNavigationFlag();
  }

  FetchExistingLead() {
    this.custInfoService.getLeadInfo(this.dataService.leadDetails).subscribe((data: Lead) => {
      this.custDetails = data;
      this.dataService.leadHistory = new LeadHistory();
      this.dataService.leadHistory.preValue = JSON.parse(JSON.stringify(data));
      this.dataService.leadHistory.pageNumber = 1;
      this.processDate(data);
      this.isLoading = false;
      this.setUpdaterCompanyCode();
      this.setNavigationFlag();
      this.custDetails.isPreviousBtnDisabled = true;
      $('#address-line-search-one').hide();
      $('#address-line-search-two').hide();
      if (data.isMailingAddressSame == 'Yes') {
        this.mailingAddressSame = true;
      }
      else {
        this.mailingAddressSame = false;
      }

    }, err => {
      this.isLoading = false;
      this.dataService.handleError(err);
    }
    )
  }

  ngOnDestroy() {
    this.dataService.leadDetails = this.custDetails;
    this.commonService.EmptyLeadObject();
  }
  customDateParse(value: any): Date | null {
    if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
      const str = value.split('/');

      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);

      return new Date(year, month, date);
    } else if ((typeof value === 'string') && (value.indexOf('-') > -1)) {
      const str = value.split('-');
      const year = Number(str[0]);
      const month = Number(str[1]) - 1;
      const date = Number(str[2].split(/[: T-]/)[0]);
      return new Date(year, month, date)
    }
    else if ((typeof value === 'string') && value === '') {
      return new Date();
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }
  processDate(data: Lead) {
    if (data.applicantDOB != null) {
      this.custDetails.applicantDOB = this.customDateParse(data.applicantDOB);
    }
    if (data.coApplicantDOB != null) {
      this.custDetails.coApplicantDOB = this.customDateParse(data.coApplicantDOB);
    }
    if (data.estCloseDate != null) {
      this.custDetails.estCloseDate = this.customDateParse(data.estCloseDate)
    }
  }

  getStates() {
    this.custInfoService.getStates().subscribe((data:  any)  =>  {
      this.lstStates  =  data.lstStates;
      this.lstPhoneTypes = data.lstPhones;
    }, err  =>  {
      this.isLoading  =  false;
      this.dataService.handleError(err);
    });
  }
  getPhoneTypes() {

    this.custInfoService.getPhoneTypes().subscribe((data: any) => {
      this.lstPhoneTypes = data;
    }, err => {
      this.isLoading = false;
      this.dataService.handleError(err);
    });
  }

  SetMailingAddressDetails(event) {
    this.zone.run(() => {
      if (event.street_number != undefined && event.route != undefined)
        this.custDetails.mailingAddress.streetAddress = event.street_number + ' ' + event.route;
      else if (event.route != undefined)
        this.custDetails.mailingAddress.streetAddress = event.route;
      else if (event.street_number != undefined)
        this.custDetails.mailingAddress.streetAddress = event.street_number;
      this.custDetails.mailingAddress.line2 = '';
      this.custDetails.mailingAddress.city = event.locality;
      this.custDetails.mailingAddress.state = event.admin_area_l1;
      this.custDetails.mailingAddress.county = event.admin_area_l2;
      this.custDetails.mailingAddress.zipCode = event.postal_code;
      this.mailingStreet.nativeElement.value = this.custDetails.mailingAddress.streetAddress;
      this.mailingLine2.nativeElement.value = this.custDetails.mailingAddress.line2;
      this.mailingState.nativeElement.value = this.custDetails.mailingAddress.state;
      this.mailingCity.nativeElement.value = this.custDetails.mailingAddress.city;
      this.mailingZipCode.nativeElement.value = this.custDetails.mailingAddress.zipCode;

    });
  }

  SetPropertyAddressDetails(event) {
    this.zone.run(() => {
      if (event.street_number != undefined && event.route != undefined) {
        this.custDetails.customerAddress.streetAddress = event.street_number + ' ' + event.route;
      }
      else if (event.route != undefined) {
        this.custDetails.customerAddress.streetAddress = event.route;
      }
      else if (event.street_number != undefined) {
        this.custDetails.customerAddress.streetAddress = event.street_number;
      }
      this.custDetails.customerAddress.line2 = '';
      this.custDetails.customerAddress.city = event.locality;
      this.custDetails.customerAddress.state = event.admin_area_l1;
      this.custDetails.customerAddress.county = event.admin_area_l2;
      this.custDetails.customerAddress.zipCode = event.postal_code;

      this.propStreetAddress.nativeElement.value = this.custDetails.customerAddress.streetAddress;
      this.line.nativeElement.value = this.custDetails.customerAddress.line2;
      this.state.nativeElement.value = this.custDetails.customerAddress.state;
      this.city.nativeElement.value = this.custDetails.customerAddress.city;
      this.zipCode.nativeElement.value = this.custDetails.customerAddress.zipCode;
      this.propCounty.nativeElement.value = this.custDetails.customerAddress.county;
      this.loantype.nativeElement.focus();
    });
  }

  ngAfterViewChecked() {
    $('#angularBasicCaptcha_ReloadIcon').click(function () {
    });
    if (!this.commonService.isSafariBroswer()) {
      $('.grecaptcha-badge').remove()
    }
    else {
      $('.grecaptcha-badge').css('display', 'block !important');
      $('.grecaptcha-badge').css('visibility', 'visible !important');
    } 
  }
  
  loanTypeUpdateValidation(value)
  {
    this.custDetails.loanType=value;
    this.clearEstCloseDate();
  }


  setUpdaterCompanyCode() {
    this.route.queryParams.subscribe(params => {
      this.custDetails.sourceInfo = new Source();
      this.custDetails.sourceInfo.code = params['code'];
      if (params['code'] != undefined)
        this.custDetails.isPreviousBtnDisabled = true;
    });

  }
  setNavigationFlag() {
    //this.custDetails.isIntoApplicationForm=false;
    this.router.events
      .pipe(filter((e: any) => e instanceof RoutesRecognized),
        pairwise()
      ).subscribe((e: any) => {
        if (e[0].urlAfterRedirects != '')
          this.custDetails.isIntoApplicationForm = true;
        else
          this.custDetails.isIntoApplicationForm = false;
      });
  }


  //For google re-CAPTCHA
  handleReady() {
    this.captchaRequired = false;

  }
  handleSuccess(event) {
    if (event != '') {
      this.captchaRequired = false;
    }
  }
  handleLoad() {
    this.captchaRequired = true;
  }
  handleExpire() {
    grecaptcha.reset();
    this.captchaRequired = true;
  }
  //End of Google Re-CAPTCHA
  handler(value: string): void {
    if (value == 'EstCloseDateDP') {
      this.EstCloseDateDP.nativeElement.focus();
    }
    else if (value == 'ApplicantDOBDP') {
      this.ApplicantDOBDP.nativeElement.focus();
    }
    else {
      this.coApplicantDOBDP.nativeElement.focus();
    }
  }
  ngAfterViewInit() {
    //     setTimeout(() => this.input.nativeElement.focus());
  }
  setContacteMeHidden() {
    this.isHiddenContactMe = false;
    if (this.custDetails.isDuplicateLead) {
      this.isHiddenContactMe = true;
    }
    else if (this.custDetails.leadID == '' || this.custDetails.leadID == null) {
      this.isHiddenContactMe = true;
    }
    return this.isHiddenContactMe;
  }
}

